<div class="container">
  <div class="align-items-center">
    <div class="login-container">
      <div class="text-primary text-center login-style" translate>LOGIN</div>
      <div class="text-primary text-center login-welcome" translate>LOGIN_COLMEC_B2B</div>
      <lib-language-selection></lib-language-selection>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="username" class="text-primary" translate>USERNAME</label>
          <input
            type="text"
            formControlName="username"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
          />
          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required" translate>USERNAME_REQUIRED</div>
          </div>
        </div>
        <div class="form-group">
          <label for="password" class="text-primary" translate>PASSWORD</label>
          <div class="input-group">
            <input
              [type]="fieldTextType ? 'text' : 'password'"
              formControlName="password"
              class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
            />
            <div class="input-group-append">
              <span class="input-group-text" (click)="toggleFieldTextType()">
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-eye-slash': !fieldTextType,
                    'fa-eye': fieldTextType
                  }"
                ></i>
              </span>
            </div>
          </div>
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required" translate>PASSWORD_REQUIRED</div>
          </div>
        </div>
        <div
          *ngIf="error && (error.type === ActionTypes.BadLogin || error.type === ActionTypes.BackendDown)"
          class="alert alert-danger"
        >
          <span *ngIf="error.type === ActionTypes.BadLogin" translate>LOGIN_FAILED</span>
          <span *ngIf="error.type === ActionTypes.BackendDown" translate>BACKEND_DOWN</span>
        </div>

        <div class="form-group d-flex justify-content-between align-items-center">
          <a routerLink="/forgot-password" class="forgot-password"><strong translate>FORGOT_PASSWORD</strong></a>
        </div>
        <div class="form-group d-flex justify-content-between align-items-center">
          <button *ngIf="!loading" class="btn btn-primary login-button text-uppercase" translate>LOGIN</button>
          <i *ngIf="loading" class="fa fa-spinner fa-spin fa-lg"></i>
        </div>
      </form>
    </div>

    <div class="contact-us text-center">
      <b>
        <div class="missing-login-info" translate>COLMEC_LOGIN_CONTACT_US</div>
        <div class="text-primary contact-us-info" translate>COLMEC_LOGIN_CONTACT_US_CONTACTS</div>
      </b>
    </div>
  </div>
</div>
